import { ConnectButton } from '@rainbow-me/rainbowkit'

export function ConnectWallet() {
  return <ConnectButton showBalance chainStatus="icon" />
}
